import { Action, Types } from "./authentication.actions"

export type AuthenticationState = {
  authenticated: boolean
  loading: boolean
  errors: {}
}

const initialState: AuthenticationState = {
  authenticated: false,
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): AuthenticationState => {
  switch (action.type) {
    case Types.AUTHENTICATE:
      return {
        ...state,
        authenticated: false,
        loading: true,
      }

    case Types.AUTHENTICATE_SUCCESS:
      return {
        ...state,
        authenticated: true,
        errors: {},
        loading: false,
      }

    case Types.AUTHENTICATE_FAIL:
      return {
        ...state,
        authenticated: false,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
